<template>
    <div class="kyc-view" >
        <div class="save-area" v-if="needToSave && !selectedSnapshot">
            <div class="save-area-inner">
                <button class="add-new fit-content no-margin" v-if="!savingData" @click="Save()"> Save </button>
                <button class="add-new fit-content no-margin" v-else disabled> Saving.. </button>
            </div>
        </div>
        <button 
            v-if="!(reviewMode || !!selectedSnapshot)"
            @click="createTask()" class="create-task fit-content no-margin">
            Create Task
        </button>

        <div class='snapshot-item' v-if="selectedSnapshot">
                <div>Viewing {{ selectedSnapshot.label }} snapshot of {{ dayjs(selectedSnapshot.snapshotDate, 'YYYY-MM-DD').format('DD/MM/YYYY') }}</div>
                <img @click="resetToCurrentView()" class='close-img' src="@/assets/cross.svg" alt="close" />
        </div>
        
   
        <div class="flex justify-center">
            <div class="breadcrumbs mt-20 w-full" v-if="!reviewMode">
                <router-link v-if="pageInfo.goBack" :to="pageInfo.goBack" class="main-item">
                    {{ pageInfo.title }}
                </router-link>
                <img src="@/assets/arrow-opener.svg" alt="arrow-right"  class="p-10" />
                <div class="last-item" v-if="companyData">
                    {{ companyData?.name?.value || (`${companyData?.first_name?.value} ${companyData?.last_name?.value}` ) }}
                </div>
            </div>
        </div>
        <div class="header-section"
            v-if="companyData"
            :class="reviewMode ? 'review-mode' : ''"
        >
            <div class="kyc-header flex row space-between align-center">
                <div>
                    <div class="kyc-title">{{currentSectionName}}</div>
                </div>
                <div class="flex gap-10">
                    <button @click="deleteReview()" v-if="!reviewMode && !selectedSnapshot && !localkycView" class="buttons">
                        Delete
                    </button>
                </div>
            </div>
        </div>
        <div 
            :class="reviewMode ? 'review-mode' : ''"
            class="kyc-fields-container flex column gap-40" v-if="companyData && loaded && banks">

                <!-- <TimeLine
                    v-if="PermissionChecker.viewAuditSection()"
                    :company_id="companyId"
                    :reviewMode="reviewMode || !!selectedSnapshot"
                    :key="`timeline-${companyId}`"
                /> -->
                <ClientDashboard 
                    v-if="PermissionChecker.viewDashboardSection() && companyData && !localkycView"
                    :reviewMode="reviewMode || !!selectedSnapshot"
                    :dataStructure="dataStructure"  
                    :company_id="companyId"
                    :key="`ClientDashboard-${companyId}`"
               
                    @changeCompanyData="companyUpdate"
                />
                <generalKYCView2
                    v-if="PermissionChecker.viewGeneralSection() && companyData.company_type === 'corporate' && localkycView == 'forCorporate'"
                    :company_id="companyId"
                    :reviewMode="reviewMode || !!selectedSnapshot"
                    :key="`generalKYCView2-${companyId}`"
                    :dataStructure="dataStructure" 
                />
                <div class="ubos" v-if="PermissionChecker.viewUboSection() && ['forAccountHolder', 'forShareholder'].includes(localkycView)" id="idshareholder_corporate" >
                    <div class="flex row align-center mb-20">
                        <h3 class="doc-header" v-if="companyData.company_type === 'corporate'">
                            ShareHolders that own more than 10% of the company 
                            <ProgressBar 
                            :current="totalSharesReported" 
                            :total="100" 
                            :label="`%`"
                            :text="' of Shares Reported'"
                            />
                        </h3>
                        <h3 class="doc-header" v-else >
                            {{ accountHolderTitle }}
                        </h3>
                        <div class='flex row gap-5' style="margin-left: auto" >
                            
                            <button title='collapse & expand section' class='transparent w-content button-holder' @click="toggleSection(shareholder_corporate_name)">
                                <img class="arrow-opener-section" :class="isOpenShareholder ? 'section-opened': ''" src="@/assets/arrow-opener.svg">
                            </button>

                            <button 
                                v-if="PermissionChecker.createUBOSection() && companyData.company_type === 'corporate' && !reviewMode && !selectedSnapshot"
                                class="add-new no-margin fit-content" @click="addNewElementFunc('shareholder')">
                                Add Shareholder
                            </button>
                        </div>
                    </div>
                    <div v-if="companyData.company_type === 'corporate'" class="flex column gap-20 w-full content-collapse" :id="shareholder_corporate_collapse">
                        <Shareholder v-for="(shareholder, index) in corporateShareholders"
                            :shareholder_id="shareholder._id"
                            :reviewMode="reviewMode || !!selectedSnapshot"
                            :key="`index_shareholder-${shareholder._id}`"
                        />
                    </div>
                    <div v-else class="w-full content-collapse" :id="shareholder_corporate_collapse">
                        <UBO2
                            v-for="(ubo, index) in sectionUbos"
                            :ubo_id="ubo._id"
                            :company_id="companyId"
                            :reviewMode="reviewMode || !!selectedSnapshot"
                            :key="`index_ubo-${companyId}`"
                        />
                    </div>
                </div>
                <div class="ubos mt-20" v-if="PermissionChecker.viewmbdSection() && companyData.company_type === 'corporate' && localkycView == 'forMD'" id="idmd_corporate">
                    <div class="flex row align-center mb-20">
                        <h3 class="doc-header">Managing board of directors</h3>
                        <div class='flex row gap-5' style="margin-left: auto">
                            <button title='collapse & expand section' class='transparent w-content button-holder' @click="toggleSection(md_corporate_name)">
                                <img class="arrow-opener-section" :class="isOpenMD ? 'section-opened': ''" src="@/assets/arrow-opener.svg">
                            </button>
                            <button 
                                v-if="PermissionChecker.creatembdSection() && !reviewMode && !selectedSnapshot" 
                                class="add-new no-margin fit-content" @click="addNewElementFunc('md')">Add Managing Director
                            </button>
                        </div>
                    </div>
                    <div class="flex column gap-20 w-full content-collapse" :id="md_corporate_collapse">
                        <ManagingDirrector2 
                            v-for="md in managingDirectors"
                            :key="`index_mbd-${md._id}`"
                            :md_id="md._id"
                            :reviewMode="reviewMode || !!selectedSnapshot"
                        />
                    </div>

                </div>
                <div 
                    class="flex column gap-5"
                    v-if="showTransactionProfile && localkycView == 'forTransactionProfile'">
                    <TransactionProfile
                        v-for="tr_profile in transactionProfile"
                        v-if="transactionProfile.length"
                        :transactionProfile_id="tr_profile._id"
                        :company_id="companyId"
                        :reviewMode="reviewMode || !!selectedSnapshot"
                    />
                </div>
        


            <!-- <div v-if="stateView === 'comment_section' && PermissionChecker.viewAuditSection()">
                <div class="cover-comments">
                    <CommentSection 
                        v-if="commentSection"
                        class="comment-section-block"
                        :commentSection="commentSection"
                        :disabled="!PermissionChecker.editAuditSection()"
                        @changeinput="changeComment"
                    />
                </div>

            </div>  
            <div v-else>
            </div> -->
        </div>
        <div class='loading' v-else>
            <LoaderPopup 
                :hideHeader="true"
                :message="'Loading KYC information...'"
            />
        </div>

        <AddNewElement
            v-if="addNewElement"
            :type="addNewElement"
            @close="addNewElement = null"
            :metaInfo="{
                company_id: companyId,
                remaining_shares: addNewElement == 'shareholder' ? 100 - totalSharesReported : null,
            }"
        />
     
        <PopupCover v-if="deleteObject" @close="() => deleteObject = !deleteObject">
            <ConfirmationPopup 
                @confirm="popupConfirm"
                @cancel="() => deleteObject = !deleteObject"
                :title="`Delete ${pageInfo.title}`"
                :message="`Are you sure you want to delete this ${pageInfo.title}? All the data for this review will be deleted.`"
            />
        </PopupCover>

        <PopupCover v-if="createTaskPopup" @close="() => createTaskPopup = !createTaskPopup">
            <PopupBody class='sanction-screening-comment-popup' @close="createTaskPopup = false">
                <template #header>
                    Add new Task
                </template>

                <template #body>

                <div class="world-check-info flex column gap-10">
                    <InpComponent
                        :label="`Assing To`"
                        type="options"
                        key_ref="assignee"
                        class="assign-option"
                        :options="companyAccountsForOption"
                        @inputChange="changeInputTask"
                    />
                    <div v-if="companyData.company_type === 'corporate'" 
                        class="header-of-section flex row align-center gap-10">
                            Related Section & File  
                            <div @click="addConcern()"
                                v-if="!reviewMode"
                                class="add-section flex align-center w-content">
                                <img src="@/assets/icon-addlink.svg"> Include Section 
                            </div>
                    </div>
                    <div class="concerns flex column gap-10">
                        <div class='flex row gap-10' v-for="(concern, index) of task.concerns" :key="`${task.concerns.length - 1}concern`" >
                            <InpComponent
                                v-if="companyData.company_type === 'corporate'"
                                :label="`Select Section`"
                                type="options"
                                class="assign-option"
                                :key_ref="`section_type|${index}`"
                                :value="concern.section_type"
                                :options="[
                                    { text: 'Corporate File', value: 'corporate_file' },
                                    { text: 'Individual', value: 'individual' },
                                    { text: 'Entity', value: 'entity' },
                                ]"
                                @inputChange="changeInputTaskSection"
                            />
                            <InpComponent
                                v-if="concern.section_type == 'corporate_file'"
                                :label="`Corporate File`"
                                type="options"
                                class="assign-option"
                                :value="concern.file_id"
                                :key_ref="`file_id|${index}`"
                                :options="corporateFileOption"
                                @inputChange="changeInputTaskSection"
                            />
                            <InpComponent
                                v-if="concern.section_type == 'individual'"
                                :label="`Individuals`"
                                type="options"
                                class="assign-option"
                                :value="concern.section_id"
                                :key_ref="`section_id|${index}`"
                                :options="individualFileOption"
                                @inputChange="changeInputTaskSection"
                            />
                            <InpComponent
                                v-if="concern.section_type == 'individual' && concern.section_id"
                                :label="`File`"
                                type="options"
                                class="assign-option"
                                :value="concern.file_id"
                                :key_ref="`file_id|${index}`"
                                :options="sectionFiles(concern.section_id, 'individual')"
                                @inputChange="changeInputTaskSection"
                            /> 

                            <InpComponent
                                v-if="concern.section_type == 'entity'"
                                :label="`Corporate Entity`"
                                type="options"
                                class="assign-option"
                                :value="concern.section_id"
                                :key_ref="`section_id|${index}`"
                                :options="entityFileOption"
                                @inputChange="changeInputTaskSection"
                            />
                            <InpComponent
                                v-if="concern.section_type == 'entity' && concern.section_id"
                                :label="`File`"
                                :value="concern.file_id"
                                type="options"
                                class="assign-option"
                                :key_ref="`file_id|${index}`"
                                :options="sectionFiles(concern.section_id, 'entity')"
                                @inputChange="changeInputTaskSection"
                            /> 

                        </div>
                    </div>
                    
                    <div class="header-of-section">Task Description</div>
                    <CommentSection 
                        :attrId="`task_comment`" 
                        class="markdown-content-dialog small"
                        :comment="task[`task_comment`]"
                        @changeinput="quillContent" 
                    />
                    <div>
                        <div class="header-of-section">Attach Files (optional)</div>
                        <MultiFileUploader @sendFileInfo="getFiles" class="uploadfile" />
                    </div>
                    

                    <button v-if="!creatingTask" class='auto-left w-content' @click="createTaskAction()">Confirm</button>
                    <button v-else class='auto-left w-content' disabled>Saving...</button>
                </div>
                </template>
            </PopupBody>
        </PopupCover>
        
       
      

    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch, onBeforeUnmount, nextTick } from 'vue'
import StructureChart from '@/components/StructureChart.vue'
import ManagingDirrector2 from '@/components/ManagingDirrector2.vue'

import { PermissionChecker } from '@/utils/iam_utils.js'
import API from '../api/index.js'
import SubsAPI from '../api/subsidiary'

import Shareholder from '@/components/Shareholder.vue'
import ProgressBar from '@/components/ProgressBar.vue'
import UBO2 from './UBO2.vue'
import LoaderPopup from '@/components/LoaderPopup.vue'
import generalKYCView2 from './generalKYCView2.vue'
import CommentSection from './CommentSection.vue'
import TransactionProfile from '@/components/TransactionProfile.vue'
import ClientDashboard from './ClientDashboard.vue'
import AddNewElement from '@/components/addNewElement.vue'
import dayjs from 'dayjs'
import { useRouter, useRoute } from 'vue-router'
import store from '../store';
import { onBeforeRouteLeave } from 'vue-router';
import PopupCover from '@/components/PopupCover.vue'
import ConfirmationPopup from '@/components/ConfirmationPopup.vue'
import PopupBody from '@/components/PopupBody.vue'
import TimeLine from './TimeLine.vue'
import InpComponent from '@/components/InpComponent.vue'
import { getUserType } from '@/utils/iam_utils'
import MultiFileUploader from '@/components/MultifileUploader.vue';

const deleteObject = ref(null);


const loaded = ref(false);
const showStructure = ref(false);
const router = useRouter();
const route = useRoute();
const props = defineProps(['id', 'reviewMode', 'kycView'])
const localkycView = ref(props.kycView)
const queryParams = computed(() => route.query)
const snashotID = ref(queryParams.value.snapshot)
const hightLight = ref(queryParams.value.highlight)
const confirmationNeeded = computed(() => store.state.confirmationNeeded);
const md_corporate_name = computed(() => props.id + '_md_corporate')
const md_corporate_collapse = computed(() => 'collapse_' + props.id + '_md_corporate')
const shareholder_corporate_name = computed(() => props.id + '_shareholder_corporate')
const shareholder_corporate_collapse = computed(() => 'collapse_' + props.id + '_shareholder_corporate')


const isOpenMD = computed(() => store.getters.getToggleState(md_corporate_name.value))
const isOpenShareholder = computed(() => store.getters.getToggleState(shareholder_corporate_name.value))

const corporateFileOption = computed( () => store.getters.getCorporateFilesOptions);
const individualFileOption = computed( () => store.getters.getPersonOptions);
const entityFileOption = computed( () => store.getters.getEntityOptions);




const sectionFiles = (individual_id, type) => {
    return computed(() => {
        let result = store.getters.getSectionFilesOptions(individual_id, type) 
        return result;
    }).value;
}
const createTaskPopup = ref(false);

const task = ref({
    assignee: null,
    task_comment: null,
    concerns: [],
});

const quillContent = (text) => {
    task.value.task_comment = text.text
}

const addConcern = () => {
    task.value.concerns.unshift({
        section_type: null,
        id: null,
    })
}

const fileList = ref([]);

function getFiles(event){
    fileList.value = event;
}

const HTMLElementShareholder = ref(document.getElementById(shareholder_corporate_collapse.value));
const HTMLElementMD = ref(document.getElementById(md_corporate_collapse.value))

const companyId = ref(props.id)
const corporateShareholders = computed(() => store.getters.shareholders(null))

const totalSharesReported = computed(() => {
    let total = 0;
    corporateShareholders.value.forEach(shareholder => {
        if (shareholder.percentage_held.value) {
            total += parseFloat(shareholder.percentage_held.value || 0);
        }
    })
    return total;
})

const KYC_Available = computed(() => store.getters.KYC_Available)
const needToSave = computed(() => store.getters.needToSave)
const savingData = computed(() => store.state.savingData)
const managingDirectors = computed(() => store.getters.managingDirectors(null))
const sectionUbos = computed(() => store.getters.getCorporateUbo)
const addNewElement = ref(null);
const selectedSnapshot = computed(() => store.state.selectedSnapshot)
const dataStructure = computed(() => store.state.dataStructureStore);
const companyData = computed(() => store.state.companyData);
const currentSectionName = computed(() => {
    if (!localkycView.value) {
        return 'Dashboard'
    } else if (localkycView.value == 'forCorporate') {
        return 'Corporate Information'
    } else if (localkycView.value == 'forAccountHolder') {
        return 'Account Holder Information'
    } else if (localkycView.value == 'forShareholder') {
        return 'Shareholder Information'
    } else if (localkycView.value == 'forMD') {
        return 'Managing Director Information'
    } else if (localkycView.value == 'forTransactionProfile') {
        return 'Transaction Profile'
    }
})

const pageInfo = computed(() => {
    if (!companyData.value) {
        return {
            title: 'KYC',
            goBack: null,
        }
    }
    if (companyData.value.company_type === 'corporate') {
        return  {
            title: 'Corporate KYC',
            goBack: '/'
        }
    } else {
        return {
            title: 'Account Holder KYC',
            goBack: '/'
        }
    }
})

const user = computed(() => store.state.user);

const creatingTask = ref(false);
const transactionProfile = computed(() => store.state.kyc_transactionalProfile);
const banks = computed(() => store.state.banks);

const companyAccountsForOption = computed(() => {
    if (!store.state.accounts) {
        return [];
    } 
    return store.state.accounts.map(account => {
        return {
            text: `${account.username} (${getUserType(account.type)})`,
            value: account._id
        }
    })

})

const showTransactionProfile = computed(() => {
    return (
        companyData.value.transaction_profile_report.new_value || 
        companyData.value.transaction_profile_report.value
    ) === 'YES'
})


async function deleteReview(){
    deleteObject.value = true;
}
async function popupConfirm() {
    const goBack = pageInfo.value.goBack
    await store.dispatch('deleteKycSection', {company_id: companyId.value })
    router.push(goBack)
}

const accountHolderTitle = computed(() => {
    const labelsDict = {
        'bank': 'Account holder Bank',
        'credit_union': 'Account holder Credit Union',
        'pention': 'Account Holder Pension',
        'insurance': 'Account Holder Insurance',
        'player': 'Account Holder Player'
    }
    return labelsDict[companyData.value.account_holder_type] || 'Account holder'
})

async function changeInputTask(event){
    task.value.assignee = event[1];
}


async function createTaskAction(){
    try {
        creatingTask.value = true;
        let fileIds = []
        for (let file of fileList.value) {
            let fileId = await API.uploadTaskFile(file);
            fileIds.push(fileId);
        }

        let taskResponse = await API.createTask({
            task: task.value,
            fileIds: fileIds,
            company_id: companyId.value,

        });
        if (taskResponse.status == 'success' ) {
            store.dispatch('addNotification', {text: 'Task created successfully', type: 'success'})
        }
    }
    catch (error) {
        console.log('Error creating task', error)
        store.dispatch('addNotification', {text: 'Error creating task', type: 'error'})
    } finally {
        creatingTask.value = false;
        task.value = {
            type: null,
            assignee: null,
            comment: '',
            concerns: [],
        };
        createTaskPopup.value = false;
    }

}

async function changeInputTaskSection(event) {
    const el = event[0].split('|');
    const type = el[0];
    const index = +el[1];
    const value = event[1];
    task.value.concerns[index][type] = value;
}

async function loadData() {
    // if opened from review does not load resources again
    if (props.reviewMode) {
        return;
    }
    loaded.value = false;
    let id = null;
    if (snashotID.value) {
        id = snashotID.value
        let data = await API.getSnapshotList();
        const selected = data.snapshots.find(snapshot => snapshot._id === id);
        store.dispatch('setValue', { key: 'selectedSnapshot', value: selected }) 
        id = selected.snapshot_id
    } else {
        const response = await API.getNotificationList({page: 1, view: 'forConfirmation', id: companyId.value});
        store.state.confirmationNeeded = response.notifications;
    }
    await SubsAPI.getSubsidiaries(companyId.value, id);

    const responseNew = await API.getKycFilesV2({snapshot_id: id, company_id: companyId.value});
    if (!companyData.value) {
        await API.loadDashboardData({company_id: companyId.value, snapshot_id: id});
    }
    console.log('LOADED DATA')
    loaded.value = true;
    store.dispatch('setValue', { key: 'approvedActions', value: 0 })
}

async function resetToCurrentView(){
    snashotID.value = null;
    store.dispatch('setValue', { key: 'selectedSnapshot', value: null })
    router.replace({query: {}})
    await loadData();
}
const handleBeforeUnload = (event) => {
    if (!needToSave.value) return;
    event.preventDefault();
    event.returnValue = "You have unsaved changes. Are you sure you want to leave?";
};
 
async function createTask() {
    await API.getUserAccounts();

    createTaskPopup.value = true;
}

function adjustHeight() {
    HTMLElementShareholder.value = document.getElementById(shareholder_corporate_collapse.value);
    HTMLElementMD.value = document.getElementById(md_corporate_collapse.value);

    if (HTMLElementShareholder.value) {
        if (isOpenShareholder.value) {
            HTMLElementShareholder.value.style.maxHeight = "none"; // Prevent transition issues
            HTMLElementShareholder.value.style.overflowY = "visible"; // Prevent overflow
        } 
        else {
            HTMLElementShareholder.value.style.maxHeight = "0"; // Collapse the section
            HTMLElementShareholder.value.style.overflowY = "hidden"; // Hide overflow
        }
    }
    if (HTMLElementMD.value) {
        if (isOpenMD.value) {
            HTMLElementMD.value.style.maxHeight = "none"; // Prevent transition issues
            HTMLElementMD.value.style.overflowY = "visible"; // Prevent overflow
        } 
        else {
            HTMLElementMD.value.style.maxHeight = "0"; // Collapse the section
            HTMLElementMD.value.style.overflowY = "hidden"; // Hide overflow
        }
    }
   
}

function toggleSection(type) {
    store.dispatch('toggleSection', {
        id: type, 
    })
}

function scrollSection(){
    hightLight.value = route.query.highlight;
    if (!hightLight.value) return;
    const element = document.getElementById(hightLight.value);
    console.log('scrollSection', hightLight.value, element)
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        element.classList.add('highlight');
        // setTimeout(() => {
        //     element.classList.remove('highlight');
        // }, 2000);
    }
}
onMounted(async() => {
    console.log('KYC mounted')
    if (!user.value) {
        router.push('/login')
        return;
    }
  

    store.dispatch('setValue', { key: 'currentSectionId', value: companyId.value })
    await loadData();
    adjustHeight()
    if (PermissionChecker.viewRequestLog()) {
        await API.getNotificationCount({view: 'forConfirmation', id: companyId.value});
    }
    document.title = `KYC - ${companyData.value?.name?.value || (companyData.value?.first_name?.value + ' ' + companyData.value?.last_name?.value)} `
    window.addEventListener("beforeunload", handleBeforeUnload);
    scrollSection();
});

onUnmounted(() => {
    console.log('KYC unmounted')
    store.dispatch('setValue', { key: 'selectedSnapshot', value: null })
    window.removeEventListener("beforeunload", handleBeforeUnload);
});

watch(() => props.kycView, (newVal) => {
    localkycView.value = newVal;
    nextTick(() => {
        adjustHeight();
        scrollSection();
    });
});

onBeforeRouteLeave((to, from, next) => {
    if (!KYC_Available.value){
        next();
        return;
    }
    if (
        !to.path.includes(companyData.value._id)
    ) {
        console.log('Leaving the page');
        store.dispatch('setValue', { key: 'companyData', value: null })
    }
    if (needToSave.value) {
        const answer = window.confirm('You have unsaved changes. Are you sure you want to leave?');
        if (!answer) {
        next(false); // Stay on the page
        return;
        }
    }
    next(); // Proceed with navigation
});

function addNewElementFunc(type){
    addNewElement.value = type;
}

async function Save(){
    if (selectedSnapshot.value) {
        store.dispatch('addNotification', {text: 'You are viewing a snapshot, please go back to the current view to save changes', type: 'error'})
    } else {
        store.dispatch('saveKycValues')
    }
}


function companyUpdate(value) {
    companyData.value = value
}

</script>

<style scoped lang="scss">

    .notifications {
       position: relative;

    }
    .structure-button {
        white-space: nowrap;
    }
    .structure-view[class] {
        // &:deep(.container) {
            width: 90vw;
            height: 80vh;
        // }
    }
    .notification-counter {
        background: #f59f9f;
        border-radius: 50%;
        padding: 5px;
        top: -2px;
        right: -20px;
        position: absolute;
        min-height: 16px;
        min-width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .popup-content {
        position: relative;
        width: 100%;
        min-height: 150px;
    }
    .popup-close {
        position: absolute;
        right: 10px;
        top: -5px;
        cursor: pointer;
    }
    .content-popup {
        display: flex;
        justify-content: center;
        gap: 20px;
        flex: 1;
        align-items: center;


        .option-select {
            padding: 10px 20px;
            cursor: pointer;
            border: 1px solid #3c556e;
            border-radius: 5px;
        }
    }
    .popup-content {
        display: flex;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
        .option-select {
            padding: 10px 20px;
            height: fit-content;
            cursor: pointer;
            border: 1px solid #3c556e;
            border-radius: 5px;
        }
    }
    .loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
    }
    .cover-comments {
        border-radius: 10px;
        padding: 20px;
        border: 1px solid var(--border-color);
        background-color: white;

        &:deep(.editor-section) {
            min-height: 50vh;
        }
    }
    .header-section {
        padding: 0 20px;
        height: 50px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        margin-bottom: -20px;
        max-width: 1350px;
        box-sizing: border-box;
        margin: auto;
    }
    .kyc-title {
        font-weight: 600;
    }
    .kyc-header {
        max-width: 1350px;
        width: 100%;
        text-align: left;
        font-size: 28px;
        position: relative;
        color: black;

        gap: 10px;
        display: flex;
        flex-direction: column;
    }
    .kyc-fields-container {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        max-width: 1350px;
        margin: auto;
        display: flex;
        justify-content: center;
        flex-direction: column;
        // align-items: center;
    }
    .kyc-fields-area {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: baseline;
       
    }
    .kyc-item-section {
        max-width: 1350px;
        width: 100%;
        margin-bottom: 30px;
        h3 {
            text-align: left;
        }
        &.extra-margin {
            margin-bottom: 50px;
        }
    }
    .flex {
        display: flex;
        &.row {
            flex-direction: row;
        }
        &.column {
            flex-direction: column;
        }
    }
    .passport-fields {
        margin-top: 20px;
    }
    .gap30 {
        gap: 30px;
    }
    textarea {
        resize: none; 
        box-sizing: border-box;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        padding: 15px;
        width: 685px;
        height: 150px;
    }
    .add-new {
        margin-left: auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .no-margin[class] {
        margin-top: 0;
        margin-bottom: 0;
    }
    .no-margin-top {
        margin-top: 0;
    }
    .margin-top-20 {
        margin-top: 20px;
    }
    .header-of-section {
        font-size: 24px;
    }

    .snapshot-item {
        position: fixed;
        top: 60px;
        right: 0px;
        padding: 10px 20px;
        border-bottom-left-radius: 30px;
        border: 1px solid var(--border-color);
        z-index: 1001;
        font-weight: bold;
        cursor: pointer;
        background: white;
        color: black;
        padding-right: 30px;
    }

    .close-img {
        position: absolute;
        width: 12px;
        top: 7px;
        right: 5px;
        padding: 2px;

        cursor: pointer;
    }
    .comment-section-block {
        height: 75vh;
        max-height: 75vh;
    }
    .save-area {

        position: fixed;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        left: calc(var(--sidebar-width) - 8px);
        width: calc(100% - var(--sidebar-width));
        z-index: 1000;

    }
    .save-area-inner {
        max-width: 1310px;
        width: 100%;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        background: white;
        border: 1px solid var(--border-color);
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        justify-content: flex-start;
        align-items: center;
        padding: 5px;
        button {
            height: 35px;
            margin-left: unset;
        }
    }
    .loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 30px;
    }
    .review-mode[class] {
        padding: 0;
    }
    .disclaimer {
        // color: #dc3434;
        border: 1px solid #dc3434;
        border-radius: 5px;
        background: white;
        font-weight: bold;
        font-size: 11px;
        padding: 10px;
    }
    .requirement {
        max-width: 1350px;
        margin: auto;
        // background: #f5f5f5;
    }
    .create-task {
        position: fixed;
        bottom: 10px;
        padding: 15px;
        right: 10px;
        z-index: 1000;
    }
    .markdown-content {
        width: 100%;
    }
    .markdown-content-dialog[class] {
      height: 250px;
      width: 100%;
    }
    .sanction-screening-comment-popup[class] {
      min-width: 1000px;
      max-width: 90vw;
      width: fit-content;
      min-height: 350px;
    }

    .assign-option {
        min-width: 300px;
        max-width: 500px;
        width: fit-content;
        margin-bottom: 20px;
    }

    .header-of-section {
        color: black;
        text-align: left;
        font-weight: 600;
        font-size: 16px;
    }
    .auto-left {
        margin-left: auto;
    }
    .add-section {
        text-align: right;
        color: var(--primary-color);
        font-size: 12px;
        justify-content: flex-end;
        gap: 5px;
        cursor: pointer;
    }
</style>